export var types = [
    'air compressor',
    'all terrain crane',
    'articulated dump truck',
    'asphalt paver machine',
    'asphalt saw cutter',
    'asphalt team',
    'backhoe loader',
    'bitumen tanker',
    'boom lift',
    'boom loader',
    'box truck',
    'bulldozer',
    'bundle puller',
    'bus',
    'concrete mixer',
    'concrete pump',
    'construction barge',
    'crawler crane',
    'diesel tanker',
    'double drum roller',
    'dump truck',
    'excavator attachment',
    'excavator crawler',
    'excavator long boom',
    'excavator wheel',
    'flat top barge',
    'forklift',
    'generator',
    'hiab crane',
    'laser scanner',
    'lifting cradle',
    'lighting tower',
    'loadbank',
    'lowbed',
    'flatbed',
    'man lift',
    'milling machine',
    'mobile tire crane',
    'motor grader',
    'pickup truck',
    'plate compactor',
    'pneumatic tyred roller',
    'power pallet truck',
    'push barge',
    'reach truck',
    'recovery truck',
    'refrigerated truck',
    'refrigerated van',
    'rigid truck',
    'ride on roller',
    'ride on scrubber',
    'rough terrain crane',
    'scissor lift',
    'single drum roller',
    'skid steer loader',
    'spider crane',
    'spider lift',
    'stabilizer',
    'sweet water tanker',
    'trailer',
    'trencher',
    'truck mounted man lift',
    'tug boat',
    'walk behind compactor',
    'waste water tanker',
    'water tanker',
    'vaccum tanker',
    'van',
    'wheel loader shovel',
].map(function (a) { return ({
    value: a,
    label: a.replace(/^\w/, function (c) { return c.toUpperCase(); }),
}); });
export var subtypes = [
    {
        value: 'wheel',
        label: 'Wheel',
    },
    {
        value: 'track',
        label: 'Track',
    },
];
export var units = [
    {
        value: 'ton',
        label: 'Ton',
    },
    {
        value: 'feet',
        label: 'Feet',
    },
    {
        value: 'kg',
        label: 'kg',
    },
    {
        value: 'metres',
        label: 'Metres',
    },
    {
        value: 'gallon',
        label: 'Gallon',
    },
    {
        value: 'cubic metres',
        label: 'Cubic Metres',
    },
    {
        value: 'seats',
        label: 'Seats',
    },
    {
        value: 'watt',
        label: 'Watt',
    },
    {
        value: 'kva',
        label: 'kVA',
    },
    {
        value: 'cfm',
        label: 'CFM',
    },
    {
        value: 'inches',
        label: 'Inches',
    },
    {
        value: 'heads',
        label: 'Heads',
    },
    {
        value: 'axle',
        label: 'Axle',
    },
    {
        value: 'hp',
        label: 'HP',
    },
    {
        value: 'centimetres',
        label: 'Centimetres',
    },
];
export var categories = [
    {
        value: '',
        label: 'All Categories',
    },
    {
        value: 'heavy',
        label: 'Heavy Equipment',
    },
    {
        value: 'lifting',
        label: 'Lifting Equipment',
    },
    {
        value: 'vehicles',
        label: 'Vehicles',
    },
    {
        value: 'teams',
        label: 'Teams',
    },
];
/*

{
  value: 'light',
  label: 'Light Equipment',
},
{
  value: 'marine',
  label: 'Marine Equipment'
}
*/
export var uae_states = ['DXB', 'AUH', 'SHJ', 'AJM', 'RAK', 'UAQ', 'FUJ'].map(function (a) { return ({ value: a, label: a }); });
export var locations = [
    {
        value: 'DXB',
        label: 'Dubai (DXB)',
    },
    {
        value: 'SHJ',
        label: 'Sharjah (SHJ)',
    },
    {
        value: 'RAK',
        label: 'Ras Al Khaimah (RAK)',
    },
    {
        value: 'AJM',
        label: 'Ajman (AJM)',
    },
    {
        value: 'FUJ',
        label: 'Fujairah (FUJ)',
    },
    {
        value: 'AUH',
        label: 'Abu Dhabi (AUH)',
    },
    {
        value: 'UAQ',
        label: 'Umm Al Quwain (UAQ)',
    },
];
export var manufacturers = [
    'Hitachi',
    'Caterpillar',
    'Beligium',
    'South korea',
    'United state',
    'hyundai',
    'China',
    'Hyundai',
    'Japan',
    'Germany',
    'india',
    'India',
    'sweden',
    'Emirates',
    'Hungary',
    'Italy',
    'germany',
    'Brazil',
    'Spain',
    'Sweden',
    'MAN',
    'Mercedes',
    'HinoZS',
    'Belgium',
    'Belgium ',
    'America',
    'United states',
].map(function (a) { return ({
    value: a,
    label: a,
}); });
export var lifecycle = [
    {
        value: 'in yard',
        label: 'In yard',
    },
    {
        value: 'scheduled',
        label: 'Scheduled',
    },
    {
        value: 'dispatched',
        label: 'Dispatched',
    },
    {
        value: 'in transit',
        label: 'In transit',
    },
    {
        value: 'landed',
        label: 'Landed',
    },
    {
        value: 'working',
        label: 'Working',
    },
    {
        value: 'idle',
        label: 'Idle',
    },
    {
        value: 'work order created',
        label: 'Work order created',
    },
    {
        value: 'mechanic dispatched',
        label: 'Mechanic Dispatched',
    },
    {
        value: 'under repair',
        label: 'Under Repair',
    },
    {
        value: 'demobilised',
        label: 'Demobilised',
    },
    {
        value: 'demobilised - replacement',
        label: 'Demobilised - Replaced',
    },
    {
        value: 'cancelled',
        label: 'Cancelled',
    },
];
var today = new Date();
var year = today.getFullYear();
var arr = [];
for (var i = 0; i < 30; ++i) {
    arr.push({
        value: year - i,
        label: "".concat(year - i),
    });
}
export var years = arr;
export var document_types = [
    'MULKIYA',
    'INSURANCE',
    'THIRD_PARTY_CERTIFICATE',
    'GENERAL_IMAGE',
    'MISCELLANEOUS',
];
export var operator_document_types = [
    'Emirates ID',
    'Driving License',
    'Operator License',
    'Residence Visa',
    'Passport Copy',
    'Other Docs',
];
export var countries = [
    {
        label: 'United Arab Emirates',
        code: 'AE',
        subdivision: [
            { label: 'Abu Dhabi', code: 'AZ' },
            { label: 'Dubai', code: 'DU' },
            { label: 'Sharjah', code: 'SH' },
            { label: 'Ajman', code: 'AJ' },
            { label: 'Ras Al Khaimah', code: 'RK' },
            { label: 'Fujairah', code: 'FU' },
            { label: 'Umm Al Quwain', code: 'UQ' },
        ],
    },
    {
        label: 'Saudi Arabia',
        code: 'SA',
        subdivision: [
            { label: 'Al Bahah', code: '11' },
            { label: 'Northern Borders', code: '08' },
            { label: 'Al Jawf', code: '12' },
            { label: 'Medina', code: '03' },
            { label: 'Al Qassim', code: '05' },
            { label: 'Riyadh', code: '01' },
            { label: 'Eastern Province', code: '04' },
            { label: 'Asir', code: '14' },
            { label: "Ha'il", code: '06' },
            { label: 'Jazan', code: '09' },
            { label: 'Mecca', code: '02' },
            { label: 'Najran', code: '10' },
            { label: 'Tabuk', code: '07' },
        ],
    },
];
export var StatusMessage = {
    getStatusMessage: function (status) {
        var msg;
        switch (status) {
            case 'created':
                msg = 'Request Created';
                break;
            case 'awaiting approval':
                msg = 'Awaiting Tenderd Approval';
                break;
            case 'in progress':
                msg = 'In Progress';
                break;
            case 'awaiting acceptance':
                msg = 'Awaiting Acceptance';
                break;
            case 'completed':
                msg = 'Completed';
                break;
            case 'declined':
                msg = 'Cancelled';
                break;
            default:
                msg = status;
                break;
        }
        return msg;
    },
};
export var ColorCode = {
    getRequestStatusColor: function (status) {
        var color = '#000';
        switch (status) {
            case 'created':
                color = '#95a5a6';
                break;
            case 'completed':
                color = '#009432';
                break; //dark green
            case 'awaiting approval':
                color = '#f39c12';
                break; //orange
            case 'awaiting acceptance':
                color = '#2980b9';
                break; //blue
            case 'in progress':
                color = '#2ecc71';
                break; //light green
            case 'declined':
                color = '#c0392b';
                break; //red
            case 'declined(tenderd)':
                color = '#c0392b';
                break; //red
            case 'cancelled':
                color = '#e74c3c';
                break; // lighter red
            default:
                color = '#000';
                break;
        }
        return color;
    },
    getEquipmentStatusColor: function (status) {
        var color = '#000';
        switch (status) {
            case 'in yard':
                color = '#34495e';
                break;
            case 'scheduled':
                color = '#9b59b6';
                break;
            case 'dispatched':
                color = '#7f8c8d';
                break;
            case 'in transit':
                color = '#3498db';
                break;
            case 'landed':
                color = '#2980b9';
                break;
            case 'working':
                color = '#27ae60';
                break;
            case 'idle':
                color = '#95a5a6';
                break;
            case 'work order created':
                color = '#f39c12';
                break;
            case 'mechanic dispatched':
                color = '#f39c12';
                break;
            case 'under repair':
                color = '#f39c12';
                break;
            case 'demobilised' || 'demobilised - replacement':
                color = '#d35400';
                break;
            default:
                color = '#000';
                break;
        }
        return color;
    },
    getEquipmentDocStatusColor: function (status) {
        var color = '#c0392b';
        switch (status) {
            case 'expired' || 'expiring_month':
                color = 'red';
                break; //red
            case 'expiring soon':
                color = 'orange';
                break; //orange
            case 'active':
                color = 'green';
                break; //dark green
            default:
                color = '#000';
                break;
        }
        return color;
    },
    getViolationColor: function (violation) {
        var color = '#c0392b';
        switch (violation) {
            case 'idling':
                color = '#2980b9';
                break; //blue
            case 'overspeed':
                color = '#e74c3c';
                break; // lighter red
            default:
                color = '#000';
                break;
        }
        return color;
    },
    getArrowColor: function (direction, type) {
        var color = '#000';
        if (direction === 'up' && type === 'violations') {
            color = '#c0392b'; //red
        }
        else if (direction === 'down' && type === 'violations') {
            color = '#2ecc71'; //light green
        }
        else if (direction === 'up' && type === 'work-order') {
            color = '#c0392b'; //red
        }
        else if (direction === 'down' && type === 'work-order') {
            color = '#2ecc71'; //light green
        }
        else if (direction === 'up' && type === 'work-hours') {
            color = '#2ecc71'; //light green
        }
        else if (direction === 'down' && type === 'work-hours') {
            color = '#c0392b'; //red
        }
        else if (direction === 'right') {
            color = '#f39c12'; //orange
        }
        return color;
    },
    getResponseTimeColor: function (seconds) {
        var color = '#000';
        if (seconds < 86400) {
            //24 hrs
            color = '#009432'; //light green
        }
        else if (seconds < 259200) {
            //72 hrs
            color = '#f39c12'; //orange
        }
        else {
            color = '#c0392b'; //red
        }
        return color;
    },
};
export var BDMDetails = {
    getBDMDetails: function (email) {
        var msg;
        switch (email) {
            case 'smasri@tenderd.com':
                msg = {
                    name: 'Suhail Masri',
                    email: 'smasri@tenderd.com',
                    phone: '+966 54 597 8683',
                };
                break;
            case 'm.hussain@tenderd.com':
                msg = {
                    name: 'Mushtaq Hussain',
                    email: 'm.hussain@tenderd.com',
                    phone: '+966 54 836 3373',
                };
                break;
            case 'aleh@tenderd.com':
                msg = {
                    name: 'Aleh Tsepeleu',
                    email: 'aleh@tenderd.com',
                    phone: '+971 58 501 3135',
                };
                break;
            case 'arshad@tenderd.com':
                msg = {
                    name: 'Arshad Muhammad',
                    email: 'arshad@tenderd.com',
                    phone: '+971 50 182 2159',
                };
                break;
            case 'm.hammadi@tenderd.com':
                msg = {
                    name: 'Marwan Hammadi',
                    email: 'm.hammadi@tenderd.com',
                    phone: '+971 50 182 2460',
                };
                break;
            case 'taha.banihashim@tenderd.com':
                msg = {
                    name: 'Taha Bani Hashim',
                    email: 'taha.banihashim@tenderd.com',
                    phone: '+971 50 621 0122',
                };
                break;
            case 'rqazi@tenderd.com':
                msg = {
                    name: 'Raayed Qazi',
                    email: 'rqazi@tenderd.com',
                    phone: '+971 52 915 5388',
                };
                break;
            default:
                msg = {
                    name: 'Aleh Tsepeleu',
                    email: 'aleh@tenderd.com',
                    phone: '+971 58 501 3135',
                };
                break;
        }
        return msg;
    },
};
export var BOOKMARK_GROUP_LOCAL_STORAGE_KEY = 'bookmark_group';
export var REFRESH_EQUIPMENT_LIST_TIMEOUT = 15000;
export var DISTANT_VEHICLE_DISTANCE_IN_METERS = 100000;
